import React from 'react';
import { format } from 'date-fns';
import { ChipRow, TimeChipStyled, EmptyMessage } from './chip';
import { isSameTime } from './helpers';

const TimeChips = ({ timeSlots, selectedTime, onSelectTime }) => {
  if (!timeSlots || timeSlots.length === 0) {
    return <EmptyMessage>No times available for this date</EmptyMessage>;
  }

  return (
    <ChipRow>
      {timeSlots.map((time, idx) => (
        <TimeChipStyled
          key={idx}
          type="button"
          isSelected={isSameTime(time, selectedTime)}
          onClick={() => onSelectTime(time)}>
          {format(time, 'h:mm a')}
        </TimeChipStyled>
      ))}
    </ChipRow>
  );
};

export default TimeChips;
